import { Modal } from "react-bootstrap";
import { tippingNavigate } from "../../../assests/Icons/icon";
import ThemeButton from "../../theme/ThemeButton";
import styles from "./TippingModal.module.scss";

interface IProps {
    show: boolean;
    onAddTipping: () => void;
    onKeepRatingsOnly: () => void;
    addTippingLoading?: boolean;
}

const RatingsPromptModal = ({
    show,
    onAddTipping,
    onKeepRatingsOnly,
    addTippingLoading = false,
}: IProps) => {
    return (
        <Modal
            show={show}
            onHide={addTippingLoading ? undefined : onKeepRatingsOnly}
            backdrop={addTippingLoading ? "static" : true}
            size="lg"
            className={styles.confirmationModal}
            centered
        >
            <Modal.Body>
                <div className={styles.modalContent}>
                    <h2 className={styles.modalTitle}>Welcome to TopTipper!</h2>
                    <p className={styles.modalDescription}>
                        Your location is already set up to collect customer ratings. Want to let customers leave a tip too?
                    </p>
                    <p className={`${styles.modalFooterDescription} ${styles.ratingsHelp}`}>
                        Not sure? Email us anytime at{" "}
                        <a className={styles.supportEmail} href="mailto:support@toptipper.co">
                            support@toptipper.co
                        </a>
                    </p>
                    <ThemeButton
                        onClick={onAddTipping}
                        className={styles.modalFooterButton}
                        loading={addTippingLoading}
                        disabled={addTippingLoading}
                    >
                        Add Tipping <span className="ml-2">{tippingNavigate}</span>
                    </ThemeButton>
                    <ThemeButton
                        variant="outline-light"
                        onClick={onKeepRatingsOnly}
                        className={styles.ratingsSecondaryButton}
                        disabled={addTippingLoading}
                    >
                        Keep Ratings Only
                    </ThemeButton>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default RatingsPromptModal;
